import { CanMatchFn, UrlSegment } from '@angular/router';

function isOidcCallback(segments: UrlSegment[]): boolean {
  const path = `/${segments.map(segment => segment.path).join('/')}`;
  const searchParams = new URLSearchParams(window.location.search);

  return path === '/dashboard' && searchParams.has('code') && searchParams.has('state');
}

export const notFoundGuard: CanMatchFn = (_route, segments) => {
  return !isOidcCallback(segments);
};
